export const contactTypes = {
    CUSTOMER: 'CUSTOMER',
    SUPPLIER: 'SUPPLIER',
    OTHER: 'OTHER',
};
